import React, { createRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import VideoUITileNameplate from "@platform/features/videoUI/components/VideoUITileNameplate/VideoUITileNameplate";
import { RoomMember } from "@platform/features/video/types/video.types";
import useContainerWidthBreakpoint from "@core/hooks/useContainerWidthBreakpoint";

interface VideoTileProps extends React.HTMLAttributes<HTMLDivElement> {
  tag?: React.ElementType;
  nameplate?: string;
  roomMemberData?: RoomMember | null;
}

export const PreviewVideoTile = forwardRef<HTMLVideoElement, VideoTileProps>(
  (
    { tag: Component = "div", className, nameplate, roomMemberData, ...rest },
    ref
  ) => {
    const containerRef = createRef<HTMLDivElement>();

    const { isXs, containerWidth } = useContainerWidthBreakpoint(containerRef);

    return (
      <Component
        className={twMerge(
          "bg-brand-100 h-full w-full relative rounded-md overflow-hidden aspect-video",
          className
        )}
        data-testid="preview-video-tile"
        ref={containerRef}
        {...rest}
      >
        <video 
          ref={ref} 
          className="w-full h-full object-cover" 
          playsInline 
          muted 
          autoPlay
        />
        {nameplate && (
          <VideoUITileNameplate
            nameplate={nameplate}
            isWithContentShare={false}
            isWithVideo={true}
            roomMemberData={roomMemberData}
            isXs={isXs}
            containerWidth={containerWidth}
          />
        )}
      </Component>
    );
  }
);

PreviewVideoTile.displayName = "PreviewVideoTile";

export default PreviewVideoTile;
